import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";
import userImage from "../../../assets/user-img-placeholder.jpg";

const BDUserInfo = ({ bookingDetails }) => {
  return (
    <div className="bd-p-user-info col-lg-7 col-12 d-flex flex-column align-items-start mb-3">
      <div className="bd-p-user-avatar d-flex align-items-center justify-content-center">
        <img
          src={
            bookingDetails?.profile_picture
              ? bookingDetails?.profile_picture
              : userImage
          }
          width={50}
          height={50}
          className="rounded-circle"
          alt="user avatar"
        />
        <p className="m-0 p-0 bd-p-user-info-name">
          {bookingDetails?.first_name} {bookingDetails?.last_name}
        </p>
      </div>
      <div className="bd-p-user-details mt-2">
        <p className="m-0 p-0 bd-p-header-date">
          {" "}
          <Icon icon="fluent:phone-32-regular" fontSize={18} className="me-1" />
          {bookingDetails?.phone}
        </p>

        <p className="m-0 p-0 bd-p-header-date flex-shrink-0 text-wrap text-break  word-break">
          <Icon icon="tabler:at" fontSize={18} className="me-1" />{" "}
          {bookingDetails?.email_address}
        </p>
      </div>
    </div>
  );
};

export default BDUserInfo;
